/**
 * 서명 picker 메뉴 — 작성기 푸터의 서명 아이콘 클릭 시 열림.
 *
 *   ┌──────────────────────┐
 *   │  내 서명 1            │
 *   │  내 서명 2 (기본)      │
 *   │  내 서명 3            │
 *   │  ─────────────        │
 *   │  ⚙ 내 서명 관리        │  ← 목록·수정·삭제
 *   │  ＋ 새 서명 만들기      │  ← 빈 편집기
 *   └──────────────────────┘
 *
 * ## 라벨을 고친 이유
 * 예전엔 두 항목이 "보관함" / "서명 설정" 이었는데, <b>"서명 설정" 이 여는 것은 설정 화면이
 * 아니라 빈 "새 서명" 작성기</b>였다. 메일을 쓰다 서명을 고치려고 그걸 누른 사람은 빈 화면을
 * 보고 "수정이 안 된다"고 판단한다 — 실제 수정 경로("보관함")는 이름만 봐서는 거기 있는 줄
 * 알 수 없었다. 운영 로그상 수정 대신 지우고 새로 만들기가 8회 반복된 배경이다.
 * 이제 이름이 하는 일과 일치한다.
 */
import React from "react";
import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import AddRoundedIcon            from "@mui/icons-material/AddRounded";
import EditNoteRoundedIcon       from "@mui/icons-material/EditNoteRounded";
import SettingsRoundedIcon       from "@mui/icons-material/SettingsRounded";
import StarRoundedIcon           from "@mui/icons-material/StarRounded";

export default function SignaturePickerMenu({
    open, anchorEl, onClose,
    signatures = [],
    onPick, onOpenGallery, onOpenEditor,
}) {
    return (
        <Menu
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "bottom", horizontal: "left" }}
            PaperProps={{ sx: { minWidth: 220, maxWidth: 320 } }}
        >
            {signatures.length === 0 && (
                <MenuItem disabled sx={{ fontSize: 12, color: "#94a3b8" }}>
                    저장된 서명이 없습니다
                </MenuItem>
            )}
            {signatures.map((s) => (
                <MenuItem key={s.id} onClick={() => onPick?.(s)} sx={{ fontSize: 13 }}>
                    <ListItemIcon>
                        <EditNoteRoundedIcon sx={{ fontSize: 18, color: "#64748b" }} />
                    </ListItemIcon>
                    <ListItemText
                        primary={s.name || "(이름 없음)"}
                        primaryTypographyProps={{ fontSize: 13, fontWeight: 500, noWrap: true }}
                    />
                    {s.isDefault && (
                        <Box sx={{ display: "inline-flex", alignItems: "center", ml: 1 }}>
                            <StarRoundedIcon sx={{ fontSize: 14, color: "#f59e0b" }} />
                            <Typography sx={{ fontSize: 10, ml: 0.3, color: "#f59e0b", fontWeight: 700 }}>기본</Typography>
                        </Box>
                    )}
                </MenuItem>
            ))}

            <Divider sx={{ my: 0.5 }} />

            <MenuItem onClick={onOpenGallery} sx={{ fontSize: 13 }}>
                <ListItemIcon><SettingsRoundedIcon sx={{ fontSize: 18, color: "#64748b" }} /></ListItemIcon>
                <ListItemText primary="내 서명 관리"
                    secondary="수정 · 삭제 · 기본 지정"
                    primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }}
                    secondaryTypographyProps={{ fontSize: 11, color: "#94a3b8" }} />
            </MenuItem>
            <MenuItem onClick={onOpenEditor} sx={{ fontSize: 13 }}>
                <ListItemIcon><AddRoundedIcon sx={{ fontSize: 18, color: "#64748b" }} /></ListItemIcon>
                <ListItemText primary="새 서명 만들기" primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }} />
            </MenuItem>
        </Menu>
    );
}
